// extracted by mini-css-extract-plugin
export default {"root":"SearchMapIconPin_root__kRL8o","pinImage":"SearchMapIconPin_pinImage__HURLG"};